module.exports = __webpack_public_path__ + "img/tme-162x230.48c5dfad.jpg";